// extracted by mini-css-extract-plugin
export default {"categoriesContainer":"Categories_categoriesContainer__sbYmQ","tabs":"Categories_tabs__dKF3m","tab":"Categories_tab__S9OhK"};